<template>
    <div class="invoicesInfo">
        <van-nav-bar
            title="查看开票"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="invoicesInfo-content">
            <div class="invoices-status">
                <div :class="(formInfo.invoiceStatus==1 || formInfo.invoiceStatus==2) ?'active defaultdc':'defaultdc'">
                    <div>
                        <img src="../../../assets/images/account/zhang.png" alt="">
                        <span>审核中</span>
                    </div>
                </div>
                <div :class="formInfo.invoiceStatus==2?'active defaultdc':'defaultdc'">
                   <div>
                        <img src="../../../assets/images/account/smsicon.png" alt="">
                        <span v-if="formInfo.invoiceStatus==2">已邮寄</span>
                        <span v-else>未邮寄</span>
                   </div>
                </div>
            </div>
            <div class="logistics-status" v-if="formInfo.invoiceStatus == 2">
                <div class="logistics-left">
                    快递单号
                </div>
                <div class="logistics-right">
                    <p>{{formInfo.expressNumber}}</p>
                    <p>{{formInfo.expressCompany}}</p>
                </div>
            </div>
            <div class="info-list">
                <div class="info-item">
                    <span>发票类型</span>
                    <span>{{formInfo.invoiceType==1?'普通发票':'增值税专用发票'}}</span>
                </div>
                <div class="info-item">
                    <span>开票金额</span>
                    <span class="money-num">￥{{formInfo.invoiceAmount}}</span>
                </div>
                <div class="info-item">
                    <span>发票内容</span>
                    <span>{{formInfo.invoiceContent}}</span>
                </div>
                <div class="info-item">
                    <span>发票抬头</span>
                    <span>{{formInfo.invoiceTitle}}</span>
                </div>
                <div class="info-item" v-if="formInfo.invoiceTitleType==1">
                    <span>单位税号</span>
                    <span>{{formInfo.taxNumber}}</span>
                </div>
                <div class="info-item" v-if="formInfo.invoiceType==2">
                    <span>开户银行</span>
                    <span>{{formInfo.bankName}}</span>
                </div>
                <div class="info-item" v-if="formInfo.invoiceType==2">
                    <span>银行账号</span>
                    <span>{{formInfo.bankAccount}}</span>
                </div>
                <div class="info-item" v-if="formInfo.invoiceType==2">
                    <span>注册电话</span>
                    <span>{{formInfo.registPhone}}</span>
                </div>
                <div class="info-item" v-if="formInfo.invoiceType==2">
                    <span>注册地址</span>
                    <span>{{formInfo.registAdress}}</span>
                </div>
                <div class="info-item">
                    <span>申请时间</span>
                    <span>{{formInfo.applyTime}}</span>
                </div>
                <div class="info-item">
                    <span>收件人姓名</span>
                    <span>{{formInfo.recipientName}}</span>
                </div>
                <div class="info-item">
                    <span>手机号码</span>
                    <span>{{formInfo.recipientPhone}}</span>
                </div>
                <div class="info-item">
                    <span>收件地址</span>
                    <span>{{formInfo.recipientAddress}}</span>
                </div>
                <div class="info-item">
                    <span>邮箱地址</span>
                    <span>{{formInfo.recipientEmail}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "invoicesinfo",
    data() {
        return {
          formInfo:{
              invoiceStatus:1
          },
          id:'',
        };
    },
    components: {},
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        getData(){
            this.$api.invoice.getDataDetails(this.id).then((res)=>{
                console.log(res);
                if(res.data){
                    this.formInfo = {...res.data}
                }
            })
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getData();
    }
};
</script>

<style scoped lang="stylus">
@import '../asset/css/invoices.styl'
</style>
